import { render, staticRenderFns } from "./camp_operations_home.vue?vue&type=template&id=b37bd8e0&scoped=true&"
import script from "./camp_operations_home.vue?vue&type=script&lang=js&"
export * from "./camp_operations_home.vue?vue&type=script&lang=js&"
import style0 from "./camp_operations_home.vue?vue&type=style&index=0&id=b37bd8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37bd8e0",
  null
  
)

export default component.exports